import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { ManagementModal } from "app/pages/sales-intelligence/common-components/modals/ManagementModal/ManagementModal";
import { MANAGEMENT_CANCEL_TEXT } from "app/pages/sales-intelligence/pages/management/translations/managementKeys";
import {
    SL_LIST_MANAGEMENT_REPLACE_MODAL_BTN_CONFIRM_TEXT,
    SL_LIST_MANAGEMENT_REPLACE_MODAL_TITLE_TEXT,
    SL_LIST_MANAGEMENT_REPLACE_MODAL_DETAILS_TEXT,
} from "app/pages/sales-intelligence/pages/management/translations/modals";
import { CUSTOM_REPLACE_STYLES, StyledDeleteModalHeader, StyledReplaceModalText } from "../../../styles/modal";
import type { ModalProps } from "./types";

export default function ReplaceModal({ isOpen, onConfirm, onClose }: ModalProps) {
    const translate = useTranslation();

    return (
        <ManagementModal
            customStyles={CUSTOM_REPLACE_STYLES}
            confirmBtnText={SL_LIST_MANAGEMENT_REPLACE_MODAL_BTN_CONFIRM_TEXT}
            title={
                <StyledDeleteModalHeader>
                    <StyledReplaceModalText>
                        {translate(SL_LIST_MANAGEMENT_REPLACE_MODAL_TITLE_TEXT)}
                    </StyledReplaceModalText>
                </StyledDeleteModalHeader>
            }
            details={translate(SL_LIST_MANAGEMENT_REPLACE_MODAL_DETAILS_TEXT)}
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onClose}
            cancelBtnText={MANAGEMENT_CANCEL_TEXT}
            confirmBtnType="primary"
            cancelBtnType="flat"
        />
    );
}
